import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { UiteyCabDetalleElectivasDTO } from 'src/app/core/models/campus/detalle_estudiante/detalle_estudiante';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';



import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlCampus;

@Injectable()
export class UiteyCabDetalleElectivasService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }


  getUiteyCabDetalleElectivasPorEstudinateService(peopleCodeId: String): Observable<BodyListResponse<UiteyCabDetalleElectivasDTO>> {
    return this.http.get<BodyListResponse<UiteyCabDetalleElectivasDTO>>(API_URL + '/api/v1/uiteyCabDetalleElectivas/peopleCodeId/' + peopleCodeId);
  }

  getUiteyCabDetalleElectivasService(): Observable<BodyListResponse<UiteyCabDetalleElectivasDTO>> {
    return this.http.get<BodyListResponse<UiteyCabDetalleElectivasDTO>>(API_URL + '/api/v1/uiteyCabDetalleElectivas/todos');
  }
  getGenerarUiteyCabDetalleElectivasService(periodoAcademico: String): Observable<BodyListResponse<UiteyCabDetalleElectivasDTO>> {
    return this.http.get<BodyListResponse<UiteyCabDetalleElectivasDTO>>(API_URL + '/api/v1/uiteyCabDetalleElectivas/periodoAcademico/' + periodoAcademico);
  }

  guardarUiteyCabDetalleElectivasService(uiteyCabDetalleElectivasDTO: UiteyCabDetalleElectivasDTO): Observable<any> {
    return this.http.post<UiteyCabDetalleElectivasDTO>(API_URL + '/api/v1/uiteyCabDetalleElectivas', uiteyCabDetalleElectivasDTO);
  }

  getUiteyCabDetalleElectivasPorCodigoCabElectivasService(codigoCabElectivas: string): Observable<BodyResponse<UiteyCabDetalleElectivasDTO>> {
    return this.http.get<BodyResponse<UiteyCabDetalleElectivasDTO>>(API_URL + '/api/v1/uiteyCabDetalleElectivas/' + codigoCabElectivas);
  }


}
